(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  /* =========================================================
     PRODUCT CARD VARIANTS + AJAX ADD TO CART
     Extracted working logic adapted for collection cards

     NEW: jo variant select hota hai, card ki asal price bhi
     usi variant ki price dikhati hai (sale price + compare at
     price ke sath). Selection hatne par theme ki original
     price wapas aa jati hai.
  ========================================================= */

  class ProductCardVariants extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.variants = this.readVariants();
      this.optionCount = parseInt(this.dataset.optionCount || '1', 10);
      this.selections = new Array(this.optionCount).fill(null);

      this.buttons = Array.from(this.querySelectorAll('[data-option-value]'));
      this.moreButtons = Array.from(this.querySelectorAll('[data-more]'));
      this.atcButton = this.querySelector('[data-atc]');
      this.priceEl = this.querySelector('[data-selected-price]');
      this.errorEl = this.querySelector('[data-atc-error]');

      /* Theme ka apna price element (card ke andar) */
      this.cardPriceEl = this.resolveCardPriceEl();
      this.cardPriceOriginal = this.cardPriceEl ? this.cardPriceEl.innerHTML : null;

      this.buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.onSelect(button);
        });
      });

      this.moreButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleMore(button);
        });
      });

      if (this.atcButton) {
        this.atcButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.addToCart();
        });
      }

      this.preselect();
      this.update();
    }

    readVariants() {
      const script = this.querySelector('[data-variants]');
      if (!script) return [];

      try {
        return JSON.parse(script.textContent) || [];
      } catch (e) {
        return [];
      }
    }

    hasButtonsAt(position) {
      return this.buttons.some(
        (button) => parseInt(button.dataset.optionPosition, 10) === position + 1
      );
    }

    toggleMore(button) {
      const row = button.closest('[data-option-row]');
      if (!row) return;

      const expanded = row.dataset.expanded === 'true';
      const hidden = Array.from(row.querySelectorAll('[data-extra="true"]'));

      hidden.forEach((item) => {
        item.dataset.hidden = expanded ? 'true' : 'false';
      });

      row.dataset.expanded = expanded ? 'false' : 'true';
      button.textContent = expanded ? button.dataset.labelMore : button.dataset.labelLess;
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    }

    preselect() {
      const first = this.variants.find((variant) => variant.available) || this.variants[0];
      if (!first) return;

      for (let index = 0; index < this.optionCount; index++) {
        const value = first.options[index];
        if (value === undefined) continue;

        if (!this.hasButtonsAt(index)) {
          this.selections[index] = value;
          continue;
        }

        const exists = this.buttons.some(
          (button) =>
            parseInt(button.dataset.optionPosition, 10) === index + 1 &&
            button.dataset.optionValue === value
        );

        if (exists) this.selections[index] = value;
      }
    }

    onSelect(button) {
      const position = parseInt(button.dataset.optionPosition, 10) - 1;
      const value = button.dataset.optionValue;

      this.selections[position] =
        this.selections[position] === value ? null : value;

      this.update(true);
    }

    matchedVariant() {
      if (this.variants.length === 1) return this.variants[0];

      if (this.selections.some((selection) => selection === null)) {
        return null;
      }

      return (
        this.variants.find((variant) =>
          variant.options.every(
            (option, index) => option === this.selections[index]
          )
        ) || null
      );
    }

    valueIsAvailable(position, value) {
      return this.variants.some((variant) => {
        if (!variant.available) return false;
        if (variant.options[position] !== value) return false;

        return this.selections.every(
          (selection, index) =>
            index === position ||
            !selection ||
            variant.options[index] === selection
        );
      });
    }

    updateSelectedOptionLabels() {
      this.querySelectorAll('[data-option-row]').forEach((row) => {
        const label = row.querySelector('.card-variant-options__label');
        if (!label) return;
        const selected = row.querySelector('[data-option-value][aria-pressed="true"]');
        const optionName = label.dataset.optionName || label.textContent.trim();
        label.dataset.optionName = optionName;
        label.textContent = optionName + (selected ? ': ' + selected.dataset.optionValue : '');
      });
    }

    update(changeImage = false) {
      this.buttons.forEach((button) => {
        const position =
          parseInt(button.dataset.optionPosition, 10) - 1;
        const value = button.dataset.optionValue;
        const selected = this.selections[position] === value;

        button.setAttribute(
          'aria-pressed',
          selected ? 'true' : 'false'
        );

        button.dataset.unavailable = this.valueIsAvailable(
          position,
          value
        )
          ? 'false'
          : 'true';

        if (selected && button.dataset.hidden === 'true') {
          const row = button.closest('[data-option-row]');
          const moreButton = row
            ? row.querySelector('[data-more]')
            : null;

          if (moreButton) this.toggleMore(moreButton);
        }
      });

      this.updateSelectedOptionLabels();

      const variant = this.matchedVariant();

      if (this.priceEl) {
        this.priceEl.innerHTML = variant ? variant.price : '';
      }

      /* Card ki asal price selected variant ke sath badalti hai */
      this.updateCardPrice(variant);

      if (changeImage && variant && variant.image && this.buttons.length) {
        this.swapImage(variant.image);
      }

      if (this.atcButton) {
        const labels = {
          idle: this.atcButton.dataset.labelIdle,
          soldOut: this.atcButton.dataset.labelSoldOut,
          choose: this.atcButton.dataset.labelChoose
        };

        if (!variant) {
          this.atcButton.disabled = true;
          this.atcButton.textContent = labels.choose;
        } else if (!variant.available) {
          this.atcButton.disabled = true;
          this.atcButton.textContent = labels.soldOut;
        } else {
          this.atcButton.disabled = false;
          this.atcButton.textContent = labels.idle;
        }
      }

      this.hideError();
    }

    /* =========================================================
       SELECTED VARIANT PRICE

       Har theme ka price block alag markup deta hai, is liye
       card ke andar sab se pehla price-jaisa element dhoond kar
       usi ke andar likhte hain. Original HTML yaad rakha jata
       hai taake selection hatne par wapas aa sake.
    ========================================================= */

    resolveCardPriceEl() {
      const card = this.closest('.product-grid__item') || this.parentElement;
      if (!card) return null;

      const selectors = [
        '[data-testid="price"]',
        'product-price',
        '.price',
        '.product-price',
        '[class*="price"]'
      ];

      for (const selector of selectors) {
        const found = Array.from(card.querySelectorAll(selector)).find((el) => {
          if (el === this || this.contains(el)) return false;
          if (el.tagName === 'SCRIPT' || el.tagName === 'TEMPLATE' || el.tagName === 'STYLE') {
            return false;
          }
          return true;
        });

        if (found) return found;
      }

      return null;
    }

    updateCardPrice(variant) {
      if (this.dataset.syncPrice === 'false') return;

      if (!this.cardPriceEl) {
        this.cardPriceEl = this.resolveCardPriceEl();
        if (!this.cardPriceEl) return;
        this.cardPriceOriginal = this.cardPriceEl.innerHTML;
      }

      /* Mukammal selection nahi — theme ki original price wapas */
      if (!variant) {
        if (this.cardPriceOriginal != null) {
          this.cardPriceEl.innerHTML = this.cardPriceOriginal;
        }
        return;
      }

      const onSale =
        variant.compare_at_price &&
        Number(variant.compare_at_price_raw) > Number(variant.price_raw);

      let html =
        '<span class="card-price__current' +
        (onSale ? ' card-price__current--sale' : '') +
        '">' +
        variant.price +
        '</span>';

      if (onSale) {
        html +=
          '<span class="card-price__compare">' +
          variant.compare_at_price +
          '</span>';
      }

      this.cardPriceEl.innerHTML = html;
    }

    swapImage(url) {
      if (this.dataset.swapImage !== 'true') return;

      const card = this.closest('.product-grid__item');
      if (!card) return;

      const img = card.querySelector('img');
      if (!img) return;

      try {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = url;
      } catch (e) {
        /* no-op */
      }
    }

    showError(message) {
      if (!this.errorEl) return;

      this.errorEl.textContent = message;
      this.errorEl.dataset.visible = 'true';
    }

    hideError() {
      if (!this.errorEl) return;

      this.errorEl.dataset.visible = 'false';
    }

    async addToCart() {
      const variant = this.matchedVariant();

      if (!variant || !variant.available || !this.atcButton) {
        return;
      }

      const button = this.atcButton;
      const idleLabel = button.dataset.labelIdle;
      const root =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        '/';

      button.dataset.state = 'loading';
      button.textContent = button.dataset.labelLoading;
      this.hideError();

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variant.id,
                quantity: 1
              }
            ]
          })
        });

        if (!response.ok) {
          const data = await response
            .json()
            .catch(() => ({}));

          throw new Error(
            data.description ||
              data.message ||
              'Could not add to cart'
          );
        }

        button.dataset.state = 'done';
        button.textContent = button.dataset.labelAdded;

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { source: 'product-card' }
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true
          })
        );

        if (this.dataset.afterAdd === 'cart') {
          window.location.href = root + 'cart';
          return;
        }

        if (this.dataset.afterAdd === 'drawer') {
          const drawer = document.querySelector(
            'cart-drawer, cart-drawer-component, #cart-drawer'
          );

          if (drawer) {
            if (typeof drawer.open === 'function') {
              drawer.open();
            } else if (typeof drawer.showModal === 'function') {
              drawer.showModal();
            }
          }
        }

        window.setTimeout(() => {
          button.dataset.state = 'idle';
          button.textContent = idleLabel;
        }, 1800);
      } catch (error) {
        button.dataset.state = 'idle';
        button.textContent = idleLabel;

        this.showError(
          error.message || 'Something went wrong'
        );
      }
    }
  }

  if (!customElements.get('product-card-variants')) {
    customElements.define(
      'product-card-variants',
      ProductCardVariants
    );
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-balloon-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.pa-balloons:not([data-pa-motion-initialized])';

    const initialize = (scope = document) => {
      scope.querySelectorAll(selector).forEach((section) => {
        section.dataset.paMotionInitialized = 'true';

        const items = [
          section.querySelector('.pa-balloons__header'),
          section.querySelector('.pa-balloons__feature'),
          ...section.querySelectorAll('.pa-balloons__category'),
          section.querySelector('.pa-balloons__custom')
        ].filter(Boolean);

        items.forEach((item, index) => {
          item.style.setProperty('--pa-motion-delay', `${Math.min(index * 85, 425)}ms`);
        });

        section.classList.add('pa-motion-ready');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('pa-motion-visible'));
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('pa-motion-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

        items.forEach((item) => observer.observe(item));
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-celebration-edit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      root.querySelectorAll('[data-pa-edit]').forEach((section) => {
        if (section.dataset.paEditInitialized === 'true') return;
        section.dataset.paEditInitialized = 'true';

        const track = section.querySelector('[data-pa-edit-track]');
        const previous = section.querySelector('[data-pa-edit-prev]');
        const next = section.querySelector('[data-pa-edit-next]');

        const updateControls = () => {
          if (!track || !previous || !next) return;
          const maximum = track.scrollWidth - track.clientWidth;
          previous.disabled = track.scrollLeft <= 3;
          next.disabled = track.scrollLeft >= maximum - 3;
        };

        const move = (direction) => {
          if (!track) return;
          const card = track.querySelector('.pa-celebration-edit__item');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        };

        if (previous) previous.addEventListener('click', () => move(-1));
        if (next) next.addEventListener('click', () => move(1));
        if (track) track.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls, { passive: true });
        updateControls();

        if (section.dataset.paAnimate !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          section.classList.add('is-visible');
          return;
        }

        section.classList.add('is-ready');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14 });

        observer.observe(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-custom-theme-studio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      root.querySelectorAll('[data-pa-custom-theme]').forEach((section) => {
        if (section.dataset.paInitialized === 'true') return;
        section.dataset.paInitialized = 'true';

        if (section.dataset.paAnimate !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          section.classList.add('is-visible');
          return;
        }

        section.classList.add('is-ready');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.16 });

        observer.observe(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-featured-occasions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.pa-featured-occasions');

    sections.forEach((section) => {
      const items = section.querySelectorAll('.pa-featured-occasions__reveal');

      if (!('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      items.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-party-supplies-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.pa-party-supplies:not([data-pa-motion-initialized])';

    const initialize = (scope = document) => {
      scope.querySelectorAll(selector).forEach((section) => {
        section.dataset.paMotionInitialized = 'true';

        const items = [
          section.querySelector('.pa-party-supplies__header'),
          section.querySelector('.pa-party-supplies__media'),
          section.querySelector('.pa-party-supplies__copy'),
          ...section.querySelectorAll('.pa-party-supplies__row'),
          section.querySelector('.pa-party-supplies__button')
        ].filter(Boolean);

        items.forEach((item, index) => {
          item.style.setProperty('--pa-motion-delay', `${Math.min(index * 80, 480)}ms`);
        });

        section.classList.add('pa-motion-ready');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('pa-motion-visible'));
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('pa-motion-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

        items.forEach((item) => observer.observe(item));
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    

class ProductCardVariants extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this.variants = this.readVariants();
    this.optionCount = parseInt(this.dataset.optionCount || '1', 10);
    this.selections = new Array(this.optionCount).fill(null);

    this.buttons = Array.from(this.querySelectorAll('[data-option-value]'));
    this.moreButtons = Array.from(this.querySelectorAll('[data-more]'));
    this.atcButton = this.querySelector('[data-atc]');
    this.priceEl = this.querySelector('[data-selected-price]');
    this.errorEl = this.querySelector('[data-atc-error]');

    /* Theme ka apna price element (card ke andar) — variant ke sath update hoga */
    this.cardPriceEl = this.resolveCardPriceEl();
    this.cardPriceOriginal = this.cardPriceEl ? this.cardPriceEl.innerHTML : null;

    this.buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.onSelect(button);
      });
    });

    this.moreButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleMore(button);
      });
    });

    if (this.atcButton) {
      this.atcButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.addToCart();
      });
    }

    this.preselect();
    this.update();
  }

  readVariants() {
    const script = this.querySelector('[data-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  /* Kya is option position ke liye koi clickable button maujood hai? */
  hasButtonsAt(position) {
    return this.buttons.some((b) => parseInt(b.dataset.optionPosition, 10) === position + 1);
  }

  /* Extra variants ko wahin expand / collapse karta hai */
  toggleMore(button) {
    const row = button.closest('[data-option-row]');
    if (!row) return;

    const expanded = row.dataset.expanded === 'true';
    const hidden = Array.from(row.querySelectorAll('[data-extra="true"]'));

    hidden.forEach((item) => {
      item.dataset.hidden = expanded ? 'true' : 'false';
    });

    row.dataset.expanded = expanded ? 'false' : 'true';
    button.textContent = expanded ? button.dataset.labelMore : button.dataset.labelLess;
    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  }

  /*
    Pehla available variant by default select ho jata hai.
    Agar kisi option ke liye koi swatch/pill render hi nahi hui
    (jaise "Default Title" wale single-variant products),
    to us position ki value seedha variant se le li jati hai —
    is tarah Add to cart shuru se hi kaam karta hai.
  */
  preselect() {
    const first = this.variants.find((v) => v.available) || this.variants[0];
    if (!first) return;

    for (let index = 0; index < this.optionCount; index++) {
      const value = first.options[index];
      if (value === undefined) continue;

      if (!this.hasButtonsAt(index)) {
        this.selections[index] = value;
        continue;
      }

      const exists = this.buttons.some(
        (b) => parseInt(b.dataset.optionPosition, 10) === index + 1 && b.dataset.optionValue === value
      );
      if (exists) this.selections[index] = value;
    }
  }

  onSelect(button) {
    const position = parseInt(button.dataset.optionPosition, 10) - 1;
    const value = button.dataset.optionValue;

    this.selections[position] = this.selections[position] === value ? null : value;
    this.update(true);
  }

  matchedVariant() {
    /* Single variant product: seedha wahi variant */
    if (this.variants.length === 1) return this.variants[0];

    if (this.selections.some((s) => s === null)) return null;

    return this.variants.find((v) =>
      v.options.every((opt, i) => opt === this.selections[i])
    ) || null;
  }

  valueIsAvailable(position, value) {
    return this.variants.some((v) => {
      if (!v.available) return false;
      if (v.options[position] !== value) return false;
      return this.selections.every((sel, i) => i === position || !sel || v.options[i] === sel);
    });
  }

  updateSelectedOptionLabels() {
    this.querySelectorAll('[data-option-row]').forEach((row) => {
      const label = row.querySelector('.card-variant-options__label');
      if (!label) return;
      const selected = row.querySelector('[data-option-value][aria-pressed="true"]');
      const optionName = label.dataset.optionName || label.textContent.trim();
      label.dataset.optionName = optionName;
      label.textContent = optionName + (selected ? ': ' + selected.dataset.optionValue : '');
    });
  }

  update(changeImage = false) {
    this.buttons.forEach((button) => {
      const position = parseInt(button.dataset.optionPosition, 10) - 1;
      const value = button.dataset.optionValue;
      const selected = this.selections[position] === value;

      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.dataset.unavailable = this.valueIsAvailable(position, value) ? 'false' : 'true';

      /* Agar selected value hidden hai to us row ko khol do */
      if (selected && button.dataset.hidden === 'true') {
        const row = button.closest('[data-option-row]');
        const moreButton = row ? row.querySelector('[data-more]') : null;
        if (moreButton) this.toggleMore(moreButton);
      }
    });

    this.updateSelectedOptionLabels();

    const variant = this.matchedVariant();

    if (this.priceEl) {
      this.priceEl.innerHTML = variant ? variant.price : '';
    }

    /* Card ki asal price ab selected variant ki price dikhati hai */
    this.updateCardPrice(variant);

    if (changeImage && variant && variant.image && this.buttons.length) this.swapImage(variant.image);

    if (this.atcButton) {
      const labels = {
        idle: this.atcButton.dataset.labelIdle,
        soldOut: this.atcButton.dataset.labelSoldOut,
        choose: this.atcButton.dataset.labelChoose,
      };

      if (!variant) {
        this.atcButton.disabled = true;
        this.atcButton.textContent = labels.choose;
      } else if (!variant.available) {
        this.atcButton.disabled = true;
        this.atcButton.textContent = labels.soldOut;
      } else {
        this.atcButton.disabled = false;
        this.atcButton.textContent = labels.idle;
      }
    }

    this.hideError();
  }

  /* =========================================================
     SELECTED VARIANT PRICE

     Theme ka price block har theme me alag markup deta hai,
     is liye card ke andar sab se pehla price-jaisa element
     dhoond kar usi ke andar likhte hain. Original markup
     yaad rakha jata hai taake selection hatne par wapas aa sake.
  ========================================================= */

  resolveCardPriceEl() {
    const card = this.closest('.resource-list__item') || this.parentElement;
    if (!card) return null;

    const selectors = [
      '[data-testid="price"]',
      'product-price',
      '.price',
      '.product-price',
      '[class*="price"]',
    ];

    for (const selector of selectors) {
      const found = Array.from(card.querySelectorAll(selector)).find((el) => {
        if (el === this || this.contains(el)) return false;
        if (el.tagName === 'SCRIPT' || el.tagName === 'TEMPLATE' || el.tagName === 'STYLE') return false;
        return true;
      });

      if (found) return found;
    }

    return null;
  }

  updateCardPrice(variant) {
    if (this.dataset.syncPrice === 'false') return;

    if (!this.cardPriceEl) {
      this.cardPriceEl = this.resolveCardPriceEl();
      if (!this.cardPriceEl) return;
      this.cardPriceOriginal = this.cardPriceEl.innerHTML;
    }

    /* Koi mukammal selection nahi — theme ki original price wapas */
    if (!variant) {
      if (this.cardPriceOriginal != null) this.cardPriceEl.innerHTML = this.cardPriceOriginal;
      return;
    }

    const onSale =
      variant.compare_at_price &&
      Number(variant.compare_at_price_raw) > Number(variant.price_raw);

    let html =
      '<span class="card-price__current' +
      (onSale ? ' card-price__current--sale' : '') +
      '">' +
      variant.price +
      '</span>';

    if (onSale) {
      html += '<span class="card-price__compare">' + variant.compare_at_price + '</span>';
    }

    this.cardPriceEl.innerHTML = html;
  }

  swapImage(url) {
    if (this.dataset.swapImage !== 'true') return;
    const card = this.closest('.resource-list__item');
    if (!card) return;
    const img = card.querySelector('img');
    if (!img) return;
    try {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
    } catch (e) {
      /* noop */
    }
  }

  showError(message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.dataset.visible = 'true';
  }

  hideError() {
    if (!this.errorEl) return;
    this.errorEl.dataset.visible = 'false';
  }

  async addToCart() {
    const variant = this.matchedVariant();
    if (!variant || !variant.available || !this.atcButton) return;

    const button = this.atcButton;
    const idleLabel = button.dataset.labelIdle;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    button.dataset.state = 'loading';
    button.textContent = button.dataset.labelLoading;
    this.hideError();

    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Could not add to cart');
      }

      button.dataset.state = 'done';
      button.textContent = button.dataset.labelAdded;

      /* Cart drawer / cart count refresh */
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'product-card' } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));

      if (this.dataset.afterAdd === 'cart') {
        window.location.href = root + 'cart';
        return;
      }

      if (this.dataset.afterAdd === 'drawer') {
        const drawer = document.querySelector('cart-drawer, cart-drawer-component, #cart-drawer');
        if (drawer) {
          if (typeof drawer.open === 'function') drawer.open();
          else if (typeof drawer.showModal === 'function') drawer.showModal();
        }
      }

      setTimeout(() => {
        button.dataset.state = 'idle';
        button.textContent = idleLabel;
      }, 1800);
    } catch (error) {
      button.dataset.state = 'idle';
      button.textContent = idleLabel;
      this.showError(error.message || 'Something went wrong');
    }
  }
}

if (!customElements.get('product-card-variants')) {
  customElements.define('product-card-variants', ProductCardVariants);
}


/* =========================================================
   MOVE HEADER BUTTON BELOW PRODUCT CARDS + RENAME VIEW ALL
========================================================= */

function placeProductListViewAllButtons(root = document) {
  const sections = [];

  if (root && root.matches && root.matches('.section-resource-list')) {
    sections.push(root);
  }

  if (root && root.querySelectorAll) {
    sections.push(...root.querySelectorAll('.section-resource-list'));
  }

  [...new Set(sections)].forEach((sectionEl) => {
    const header = sectionEl.querySelector('.section-resource-list__header');
    const slot = sectionEl.querySelector('[data-view-all-slot]');

    if (!header || !slot) return;

    /*
      _product-list-button can render with different theme button classes.
      Prefer an element that looks like a button or contains the existing
      SHOP NOW / VIEW ALL text. The collection title is a heading, so it is
      not selected here.
    */
    const candidates = Array.from(header.querySelectorAll('a, button'));

    let viewAllButton = candidates.find((el) => {
      const label = (el.textContent || '').trim();
      const className = typeof el.className === 'string' ? el.className : '';

      return (
        /^(shop\s*now|view\s*all)$/i.test(label) ||
        /button/i.test(className)
      );
    });

    /* Fallback: use the last non-heading interactive element in the header. */
    if (!viewAllButton && candidates.length) {
      viewAllButton = candidates[candidates.length - 1];
    }

    if (!viewAllButton) return;

    /* Already moved — just keep the requested text. */
    if (slot.contains(viewAllButton)) {
      viewAllButton.textContent = 'VIEW ALL';
      viewAllButton.setAttribute('aria-label', 'View all');
      viewAllButton.classList.add('section-resource-list__view-all-button');
      return;
    }

    const oldParent = viewAllButton.parentElement;

    viewAllButton.textContent = 'VIEW ALL';
    viewAllButton.setAttribute('aria-label', 'View all');
    viewAllButton.classList.add('section-resource-list__view-all-button');

    slot.appendChild(viewAllButton);

    /* Remove only wrappers that became completely empty after the move. */
    let wrapper = oldParent;
    while (wrapper && wrapper !== header) {
      const hasMeaningfulContent = wrapper.querySelector(
        'a, button, h1, h2, h3, h4, h5, h6, img, svg, video, input, select, textarea'
      );
      const hasText = (wrapper.textContent || '').trim().length > 0;

      if (!hasMeaningfulContent && !hasText) {
        const nextWrapper = wrapper.parentElement;
        wrapper.remove();
        wrapper = nextWrapper;
      } else {
        break;
      }
    }
  });
}

function initProductListViewAllButtons() {
  placeProductListViewAllButtons(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductListViewAllButtons, { once: true });
} else {
  initProductListViewAllButtons();
}

/* Shopify Theme Editor support. */
document.addEventListener('shopify:section:load', (event) => {
  placeProductListViewAllButtons(event.target || document);
});

document.addEventListener('shopify:block:select', () => {
  requestAnimationFrame(() => placeProductListViewAllButtons(document));
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class RecommendationCardVariants extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.variants = this.readVariants();
      this.optionCount = Math.max(parseInt(this.dataset.optionCount || '1', 10), 1);
      this.buttons = Array.from(this.querySelectorAll('[data-option-value]'));
      this.moreButtons = Array.from(this.querySelectorAll('[data-more]'));
      this.form = this.querySelector('form.card-atc');
      this.variantIdInput = this.querySelector('[data-variant-id]');
      this.atcButton = this.querySelector('[data-atc]');
      this.fallbackPriceEl = this.querySelector('[data-selected-price]');
      this.errorEl = this.querySelector('[data-atc-error]');
      this.cardPriceEl = this.resolveCardPriceEl();

      const initialId = Number(this.dataset.initialVariantId || 0);
      this.currentVariant =
        this.variants.find((variant) => Number(variant.id) === initialId) ||
        this.variants.find((variant) => variant.available) ||
        this.variants[0] ||
        null;

      this.selections = this.currentVariant
        ? this.currentVariant.options.slice(0, this.optionCount)
        : new Array(this.optionCount).fill(null);

      this.buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.selectOption(button);
        });
      });

      this.moreButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggleMore(button);
        });
      });

      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.addToCart();
        });
      }

      this.update();
    }

    readVariants() {
      const script = this.querySelector('[data-variants]');
      if (!script) return [];

      try {
        const variants = JSON.parse(script.textContent);
        return Array.isArray(variants) ? variants : [];
      } catch (error) {
        return [];
      }
    }

    toggleMore(button) {
      const row = button.closest('[data-option-row]');
      if (!row) return;

      const expanded = row.dataset.expanded === 'true';
      row.querySelectorAll('[data-extra="true"]').forEach((item) => {
        item.dataset.hidden = expanded ? 'true' : 'false';
      });

      row.dataset.expanded = expanded ? 'false' : 'true';
      button.textContent = expanded ? button.dataset.labelMore : button.dataset.labelLess;
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    }

    selectOption(button) {
      const position = Number(button.dataset.optionPosition) - 1;
      const value = button.dataset.optionValue;
      if (position < 0 || position >= this.optionCount) return;

      const wantedSelections = this.selections.slice();
      wantedSelections[position] = value;

      let nextVariant = this.findVariant(wantedSelections);
      if (!nextVariant) nextVariant = this.bestVariantForValue(position, value);

      if (nextVariant) {
        this.currentVariant = nextVariant;
        this.selections = nextVariant.options.slice(0, this.optionCount);
      } else {
        this.currentVariant = null;
        this.selections = wantedSelections;
      }

      this.update();
    }

    findVariant(selections) {
      if (!Array.isArray(selections) || selections.some((value) => value == null)) return null;

      return this.variants.find((variant) =>
        variant.options.every((option, index) => option === selections[index])
      ) || null;
    }

    matchedVariant() {
      return this.findVariant(this.selections);
    }

    bestVariantForValue(position, value) {
      const candidates = this.variants.filter((variant) => variant.options[position] === value);
      if (!candidates.length) return null;

      return candidates
        .map((variant, index) => ({
          variant,
          index,
          matches: variant.options.reduce((score, option, optionIndex) => {
            if (optionIndex === position) return score;
            return score + (option === this.selections[optionIndex] ? 1 : 0);
          }, 0),
        }))
        .sort((a, b) => {
          if (a.variant.available !== b.variant.available) return a.variant.available ? -1 : 1;
          if (a.matches !== b.matches) return b.matches - a.matches;
          return a.index - b.index;
        })[0].variant;
    }

    valueIsAvailable(position, value) {
      const wantedSelections = this.selections.slice();
      wantedSelections[position] = value;
      const exactVariant = this.findVariant(wantedSelections);

      if (exactVariant) return Boolean(exactVariant.available);

      return this.variants.some(
        (variant) => variant.available && variant.options[position] === value
      );
    }

    update() {
      const variant = this.matchedVariant();
      this.currentVariant = variant;

      this.buttons.forEach((button) => {
        const position = Number(button.dataset.optionPosition) - 1;
        const value = button.dataset.optionValue;
        const selected = this.selections[position] === value;
        const available = this.valueIsAvailable(position, value);

        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
        button.dataset.unavailable = available ? 'false' : 'true';

        if (selected && button.dataset.hidden === 'true') {
          const row = button.closest('[data-option-row]');
          const moreButton = row ? row.querySelector('[data-more]') : null;
          if (moreButton && row.dataset.expanded !== 'true') this.toggleMore(moreButton);
        }
      });

      if (this.variantIdInput) {
        this.variantIdInput.value = variant ? String(variant.id) : '';
        this.variantIdInput.disabled = !variant;
      }

      this.updatePrice(variant);
      this.updateImage(variant);
      this.updateButton(variant);
      this.hideError();
    }

    resolveCardPriceEl() {
      const card = this.closest('.resource-list__item');
      if (!card) return null;

      const selectors = [
        'product-price',
        '[data-testid="price"]',
        '[data-product-price]',
        '.product-price',
        '.price',
        '.price__container',
      ];

      for (const selector of selectors) {
        const element = Array.from(card.querySelectorAll(selector)).find((candidate) => {
          if (candidate === this || this.contains(candidate)) return false;
          return !candidate.closest('template, script, style');
        });

        if (element) return element;
      }

      return null;
    }

    createPriceContent(variant) {
      const fragment = document.createDocumentFragment();
      if (!variant) return fragment;

      const onSale =
        variant.compare_at_price &&
        Number(variant.compare_at_price_raw) > Number(variant.price_raw);

      const currentPrice = document.createElement('span');
      currentPrice.className = 'card-price__current' + (onSale ? ' card-price__current--sale' : '');
      currentPrice.innerHTML = variant.price;
      fragment.appendChild(currentPrice);

      if (onSale) {
        const comparePrice = document.createElement('s');
        comparePrice.className = 'card-price__compare';
        comparePrice.innerHTML = variant.compare_at_price;
        fragment.appendChild(comparePrice);
      }

      return fragment;
    }

    updatePrice(variant) {
      if (!this.cardPriceEl) this.cardPriceEl = this.resolveCardPriceEl();

      const target = this.cardPriceEl || this.fallbackPriceEl;
      if (!target) return;

      if (this.fallbackPriceEl) {
        this.fallbackPriceEl.hidden = Boolean(this.cardPriceEl);
      }

      target.replaceChildren(this.createPriceContent(variant));
      target.setAttribute('aria-live', 'polite');
      target.dataset.selectedVariantPrice = variant ? String(variant.id) : '';
    }

    updateImage(variant) {
      if (this.dataset.swapImage !== 'true' || !variant || !variant.image) return;

      const card = this.closest('.resource-list__item');
      const image = card ? card.querySelector('img') : null;
      if (!image || image.src === variant.image) return;

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = variant.image;
    }

    updateButton(variant) {
      if (!this.atcButton || this.atcButton.dataset.state === 'loading') return;

      if (!variant) {
        this.atcButton.disabled = true;
        this.atcButton.textContent = this.atcButton.dataset.labelChoose;
      } else if (!variant.available) {
        this.atcButton.disabled = true;
        this.atcButton.textContent = this.atcButton.dataset.labelSoldOut;
      } else {
        this.atcButton.disabled = false;
        this.atcButton.textContent = this.atcButton.dataset.labelIdle;
      }
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.dataset.visible = 'true';
    }

    hideError() {
      if (!this.errorEl) return;
      this.errorEl.textContent = '';
      this.errorEl.dataset.visible = 'false';
    }

    cartRoutes() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const configuredAddRoute = window.routes && window.routes.cart_add_url;
      const addRoute = configuredAddRoute || root + 'cart/add';

      return {
        root,
        add: addRoute.endsWith('.js') ? addRoute : addRoute + '.js',
        cart: root + 'cart',
      };
    }

    announceCartChange(item, variant) {
      const detail = {
        source: 'recommendation-card-variants',
        product: item,
        variantId: variant.id,
      };

      document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail }));
    }

    openCartDrawer() {
      const drawer = document.querySelector(
        'cart-drawer-component, cart-drawer, #CartDrawer, #cart-drawer'
      );
      if (!drawer) return false;

      if (typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }

      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
        return true;
      }

      const dialog = drawer.matches('dialog') ? drawer : drawer.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        return true;
      }

      return false;
    }

    async addToCart() {
      const variant = this.matchedVariant();
      if (!variant || !variant.available || !this.atcButton || !this.form) return;
      if (this.atcButton.dataset.state === 'loading') return;

      const routes = this.cartRoutes();
      const formData = new FormData(this.form);
      formData.set('id', String(variant.id));
      formData.set('quantity', String(formData.get('quantity') || 1));

      this.atcButton.dataset.state = 'loading';
      this.atcButton.disabled = true;
      this.atcButton.textContent = this.atcButton.dataset.labelLoading;
      this.hideError();

      try {
        const response = await fetch(routes.add, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        const result = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(result.description || result.message || 'Could not add this variant to cart.');
        }

        this.atcButton.dataset.state = 'done';
        this.atcButton.textContent = this.atcButton.dataset.labelAdded;
        this.announceCartChange(result, variant);

        if (this.dataset.afterAdd === 'cart') {
          window.location.assign(routes.cart);
          return;
        }

        if (this.dataset.afterAdd === 'drawer') {
          requestAnimationFrame(() => this.openCartDrawer());
        }

        window.setTimeout(() => {
          this.atcButton.dataset.state = 'idle';
          this.updateButton(this.matchedVariant());
        }, 1800);
      } catch (error) {
        this.atcButton.dataset.state = 'idle';
        this.updateButton(this.matchedVariant());
        this.showError(error.message || 'Something went wrong. Please try again.');
      }
    }
  }

  if (!customElements.get('recommendation-card-variants')) {
    customElements.define('recommendation-card-variants', RecommendationCardVariants);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  class SearchProductCardVariants extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.variants = this.readVariants();
      this.optionCount = Number.parseInt(this.dataset.optionCount || '1', 10);
      this.selections = new Array(this.optionCount).fill(null);

      this.optionButtons = Array.from(this.querySelectorAll('[data-option-value]'));
      this.moreButtons = Array.from(this.querySelectorAll('[data-more]'));
      this.addButton = this.querySelector('[data-atc]');
      this.extraPriceElement = this.querySelector('[data-selected-price]');
      this.errorElement = this.querySelector('[data-atc-error]');

      this.cardPriceElement = this.resolveCardPriceElement();
      this.originalCardPrice = this.cardPriceElement ? this.cardPriceElement.innerHTML : null;

      this.optionButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.selectOption(button);
        });
      });

      this.moreButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggleMore(button);
        });
      });

      if (this.addButton) {
        this.addButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.addToCart();
        });
      }

      this.preselectFirstAvailableVariant();
      this.update();
    }

    readVariants() {
      const dataElement = this.querySelector('[data-variants]');
      if (!dataElement) return [];

      try {
        return JSON.parse(dataElement.textContent) || [];
      } catch (error) {
        return [];
      }
    }

    getCard() {
      return this.closest('.product-grid__item') || this.parentElement;
    }

    hasButtonsAt(position) {
      return this.optionButtons.some(
        (button) => Number.parseInt(button.dataset.optionPosition, 10) === position + 1
      );
    }

    toggleMore(button) {
      const row = button.closest('[data-option-row]');
      if (!row) return;

      const isExpanded = row.dataset.expanded === 'true';
      const extraItems = Array.from(row.querySelectorAll('[data-extra="true"]'));

      extraItems.forEach((item) => {
        item.dataset.hidden = isExpanded ? 'true' : 'false';
      });

      row.dataset.expanded = isExpanded ? 'false' : 'true';
      button.textContent = isExpanded ? button.dataset.labelMore : button.dataset.labelLess;
      button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    }

    preselectFirstAvailableVariant() {
      const firstVariant = this.variants.find((variant) => variant.available) || this.variants[0];
      if (!firstVariant) return;

      for (let index = 0; index < this.optionCount; index += 1) {
        const optionValue = firstVariant.options[index];
        if (optionValue === undefined) continue;

        if (!this.hasButtonsAt(index)) {
          this.selections[index] = optionValue;
          continue;
        }

        const buttonExists = this.optionButtons.some(
          (button) =>
            Number.parseInt(button.dataset.optionPosition, 10) === index + 1 &&
            button.dataset.optionValue === optionValue
        );

        if (buttonExists) this.selections[index] = optionValue;
      }
    }

    selectOption(button) {
      const position = Number.parseInt(button.dataset.optionPosition, 10) - 1;
      const value = button.dataset.optionValue;

      this.selections[position] = this.selections[position] === value ? null : value;
      this.update();
    }

    getMatchedVariant() {
      if (this.variants.length === 1) return this.variants[0];
      if (this.selections.some((selection) => selection === null)) return null;

      return (
        this.variants.find((variant) =>
          variant.options.every((option, index) => option === this.selections[index])
        ) || null
      );
    }

    valueIsAvailable(position, value) {
      return this.variants.some((variant) => {
        if (!variant.available || variant.options[position] !== value) return false;

        return this.selections.every(
          (selection, index) =>
            index === position || !selection || variant.options[index] === selection
        );
      });
    }

    update() {
      this.optionButtons.forEach((button) => {
        const position = Number.parseInt(button.dataset.optionPosition, 10) - 1;
        const value = button.dataset.optionValue;
        const isSelected = this.selections[position] === value;

        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        button.dataset.unavailable = this.valueIsAvailable(position, value) ? 'false' : 'true';

        if (isSelected && button.dataset.hidden === 'true') {
          const row = button.closest('[data-option-row]');
          const moreButton = row ? row.querySelector('[data-more]') : null;
          if (moreButton) this.toggleMore(moreButton);
        }
      });

      const variant = this.getMatchedVariant();

      if (this.extraPriceElement) {
        this.extraPriceElement.innerHTML = variant ? variant.price : '';
      }

      this.updateCardPrice(variant);

      if (variant && variant.image && this.optionButtons.length > 0) {
        this.swapCardImage(variant.image);
      }

      this.updateAddButton(variant);
      this.hideError();
    }

    updateAddButton(variant) {
      if (!this.addButton) return;

      if (!variant) {
        this.addButton.disabled = true;
        this.addButton.textContent = this.addButton.dataset.labelChoose;
        return;
      }

      if (!variant.available) {
        this.addButton.disabled = true;
        this.addButton.textContent = this.addButton.dataset.labelSoldOut;
        return;
      }

      this.addButton.disabled = false;
      this.addButton.textContent = this.addButton.dataset.labelIdle;
    }

    resolveCardPriceElement() {
      const card = this.getCard();
      if (!card) return null;

      const selectors = [
        '[data-testid="price"]',
        'product-price',
        '.price',
        '.product-price',
        '[class*="price"]',
      ];

      for (const selector of selectors) {
        const element = Array.from(card.querySelectorAll(selector)).find((candidate) => {
          if (candidate === this || this.contains(candidate)) return false;
          if (['SCRIPT', 'TEMPLATE', 'STYLE'].includes(candidate.tagName)) return false;
          return true;
        });

        if (element) return element;
      }

      return null;
    }

    updateCardPrice(variant) {
      if (this.dataset.syncPrice !== 'true') return;

      if (!this.cardPriceElement) {
        this.cardPriceElement = this.resolveCardPriceElement();
        if (!this.cardPriceElement) return;
        this.originalCardPrice = this.cardPriceElement.innerHTML;
      }

      if (!variant) {
        if (this.originalCardPrice !== null) {
          this.cardPriceElement.innerHTML = this.originalCardPrice;
        }
        return;
      }

      const isOnSale =
        variant.compare_at_price &&
        Number(variant.compare_at_price_raw) > Number(variant.price_raw);

      let priceMarkup =
        '<span class="search-card-price__current' +
        (isOnSale ? ' search-card-price__current--sale' : '') +
        '">' +
        variant.price +
        '</span>';

      if (isOnSale) {
        priceMarkup +=
          '<span class="search-card-price__compare">' + variant.compare_at_price + '</span>';
      }

      this.cardPriceElement.innerHTML = priceMarkup;
    }

    swapCardImage(url) {
      if (this.dataset.swapImage !== 'true') return;

      const card = this.getCard();
      if (!card) return;

      const imageSelectors = [
        '.product-card__image img',
        '[data-product-card-image] img',
        'product-card img',
      ];

      let image = null;

      for (const selector of imageSelectors) {
        image = card.querySelector(selector);
        if (image && !this.contains(image)) break;
        image = null;
      }

      if (!image) {
        image = Array.from(card.querySelectorAll('img')).find(
          (candidate) => !this.contains(candidate)
        );
      }

      if (!image) return;

      const picture = image.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach((source) => {
          source.removeAttribute('srcset');
          source.removeAttribute('sizes');
        });
      }

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = url;
    }

    showError(message) {
      if (!this.errorElement) return;
      this.errorElement.textContent = message;
      this.errorElement.dataset.visible = 'true';
    }

    hideError() {
      if (!this.errorElement) return;
      this.errorElement.textContent = '';
      this.errorElement.dataset.visible = 'false';
    }

    async addToCart() {
      const variant = this.getMatchedVariant();
      if (!variant || !variant.available || !this.addButton) return;

      const button = this.addButton;
      const idleLabel = button.dataset.labelIdle;
      const root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      button.disabled = true;
      button.dataset.state = 'loading';
      button.textContent = button.dataset.labelLoading;
      this.hideError();

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variant.id,
                quantity: 1,
              },
            ],
          }),
        });

        const responseData = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(
            responseData.description || responseData.message || 'Could not add to cart'
          );
        }

        button.dataset.state = 'done';
        button.textContent = button.dataset.labelAdded;

        const eventDetail = {
          source: 'search-product-card',
          productId: this.dataset.productId,
          variantId: variant.id,
          resource: responseData,
        };

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: eventDetail,
          })
        );
        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: eventDetail,
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: eventDetail,
          })
        );

        if (this.dataset.afterAdd === 'cart') {
          window.location.href = root + 'cart';
          return;
        }

        if (this.dataset.afterAdd === 'drawer') {
          const drawer = document.querySelector(
            'cart-drawer, cart-drawer-component, #cart-drawer'
          );

          if (drawer) {
            if (typeof drawer.open === 'function') {
              drawer.open();
            } else if (typeof drawer.showModal === 'function') {
              drawer.showModal();
            }
          }
        }

        window.setTimeout(() => {
          button.disabled = false;
          button.dataset.state = 'idle';
          button.textContent = idleLabel;
        }, 1800);
      } catch (error) {
        button.disabled = false;
        button.dataset.state = 'idle';
        button.textContent = idleLabel;
        this.showError(error.message || 'Something went wrong');
      }
    }
  }

  if (!customElements.get('search-product-card-variants')) {
    customElements.define('search-product-card-variants', SearchProductCardVariants);
  }

  } catch(e) { console.error(e); }
})();
})();
